const FREE_TO_AIR_DE = [
      { sat_pos: "19E", frequency_MHz: 11582, pol: "h", symbolrate_kSps: 21998 },
      { sat_pos: "19E", frequency_MHz: 11494, pol: "h", symbolrate_kSps: 21998 },
      { sat_pos: "19E", frequency_MHz: 11053, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 10891, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11362, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11347, pol: "v", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11523, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 12188, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12545, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 12480, pol: "v", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12460, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 11553, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11303, pol: "h", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11229, pol: "v", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 12226, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12148, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 11778, pol: "v", symbolrate_kSps: 29500 },
      { sat_pos: "19E", frequency_MHz: 11538, pol: "v", symbolrate_kSps: 22000 },
      { sat_pos: "19E", frequency_MHz: 11973, pol: "v", symbolrate_kSps: 27500 }
    ];

const SKY_DE = [
      // Hard match (sat_pos + frequency_MHz + pol + symbolrate_kSps)
      { sat_pos: "19E", frequency_MHz: 11758, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 11798, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 11914, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 11992, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12032, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12304, pol: "h", symbolrate_kSps: 27500 },
      { sat_pos: "19E", frequency_MHz: 12382, pol: "h", symbolrate_kSps: 27500 }
    ];

const HDPLUS = [
      // Hard match (sat_pos + frequency_MHz + pol + symbolrate_kSps)
      { sat_pos: "19E", frequency_MHz: 10832, pol: "h", symbolrate_kSps: 22000 }, // TP 057
      { sat_pos: "19E", frequency_MHz: 10773, pol: "h", symbolrate_kSps: 22000 }, // TP 053
      { sat_pos: "19E", frequency_MHz: 10803, pol: "h", symbolrate_kSps: 22000 }, // TP 055
      { sat_pos: "19E", frequency_MHz: 10964, pol: "h", symbolrate_kSps: 22000 }, // TP 033
      { sat_pos: "19E", frequency_MHz: 10994, pol: "h", symbolrate_kSps: 22000 }, // TP 035
      { sat_pos: "19E", frequency_MHz: 11082, pol: "h", symbolrate_kSps: 22000 }, // TP 041
      { sat_pos: "19E", frequency_MHz: 11112, pol: "h", symbolrate_kSps: 22000 }, // TP 043
      { sat_pos: "19E", frequency_MHz: 11464, pol: "h", symbolrate_kSps: 22000 }, // TP 017
      { sat_pos: "19E", frequency_MHz: 11391, pol: "h", symbolrate_kSps: 22000 }, // TP 013
      { sat_pos: "19E", frequency_MHz: 11186, pol: "v", symbolrate_kSps: 22000 }, // TP 048
      { sat_pos: "19E", frequency_MHz: 12344, pol: "h", symbolrate_kSps: 27500 }, // TP 097
      { sat_pos: "19E", frequency_MHz: 11973, pol: "v", symbolrate_kSps: 27500 }, // TP 078
      { sat_pos: "19E", frequency_MHz: 12574, pol: "h", symbolrate_kSps: 22000 }, // TP 109
      { sat_pos: "19E", frequency_MHz: 12640, pol: "v", symbolrate_kSps: 23500 }, // TP 114
      { sat_pos: "19E", frequency_MHz: 12670, pol: "v", symbolrate_kSps: 23500 }  // TP 116
    ];

const TELEVES_K20_16 = [
      { sat_pos: "19E", frequency_MHz: 12188, pol: "h", symbolrate_kSps: 27500 }, // [089] RTL Group
      { sat_pos: "19E", frequency_MHz: 12545, pol: "h", symbolrate_kSps: 22000 }, // [107] Pro7_Sat.1
      { sat_pos: "19E", frequency_MHz: 11494, pol: "h", symbolrate_kSps: 22000 }, // [019] ARD
      { sat_pos: "19E", frequency_MHz: 11362, pol: "h", symbolrate_kSps: 22000 }, // [011] ZDF
      { sat_pos: "19E", frequency_MHz: 11582, pol: "h", symbolrate_kSps: 22000 }, // [025] ARD
      { sat_pos: "19E", frequency_MHz: 10891, pol: "h", symbolrate_kSps: 22000 }, // [061] ARD
      { sat_pos: "19E", frequency_MHz: 11523, pol: "h", symbolrate_kSps: 22000 }, // [021] ARD
      { sat_pos: "19E", frequency_MHz: 11053, pol: "h", symbolrate_kSps: 22000 }, // [039] ARD
      { sat_pos: "19E", frequency_MHz: 12480, pol: "v", symbolrate_kSps: 27500 }, // [104] SES
      { sat_pos: "19E", frequency_MHz: 11347, pol: "v", symbolrate_kSps: 22000 }, // [010] ZDF
      { sat_pos: "19E", frequency_MHz: 12226, pol: "h", symbolrate_kSps: 27500 }, // [091] SES
      { sat_pos: "19E", frequency_MHz: 12460, pol: "h", symbolrate_kSps: 27500 }, // [103] SES
      { sat_pos: "19E", frequency_MHz: 11973, pol: "v", symbolrate_kSps: 27500 }, // [078] Paramount
      { sat_pos: "19E", frequency_MHz: 11303, pol: "h", symbolrate_kSps: 22000 }, // [007] ORF
      { sat_pos: "19E", frequency_MHz: 12148, pol: "h", symbolrate_kSps: 27500 }, // [087] SES
      { sat_pos: "19E", frequency_MHz: 11538, pol: "v", symbolrate_kSps: 22000 }  // [022] Globecast
    ];


export { FREE_TO_AIR_DE, SKY_DE, HDPLUS, TELEVES_K20_16 };
